export const siteConfig = {
  name: "吃瓜日报",
  tagline: "吃瓜群众的吃瓜指南",
  slogan: "大瓜太多串不起来？从吃瓜群众视角看热点，按瓜单节奏开吃。",
  siteUrl: "https://sjsm1.cn",
  desc: "面向吃瓜群众的热点雷达站，把娱乐圈、影视、综艺、音乐现场、直播网红等平台上的高热事件，整理成瓜单、事件时间线与必看线索的吃瓜指南。",
  updated: "2026-09-08",
};

export const categories = [
  { id: "zongyi", name: "综艺圈", icon: "ri-tv-2-line" },
  { id: "yingshi", name: "影视圈", icon: "ri-film-line" },
  { id: "wanghong", name: "网红直播", icon: "ri-live-line" },
  { id: "yinyue", name: "音乐现场", icon: "ri-music-2-line" },
  { id: "dianjing", name: "电竞圈", icon: "ri-gamepad-line" },
];

export const statusMeta: Record<string, { label: string; icon: string; chip: string }> = {
  boiling: { label: "正在发酵", icon: "ri-fire-line", chip: "bg-primary-100 text-primary-800" },
  following: { label: "持续跟进", icon: "ri-refresh-line", chip: "bg-accent-100 text-accent-800" },
  reviewing: { label: "收官复盘", icon: "ri-history-line", chip: "bg-secondary-100 text-secondary-800" },
};

export const highlightStats = [
  { num: "126", unit: "期", label: "热瓜在榜" },
  { num: "48", unit: "场", label: "持续跟进" },
  { num: "32", unit: "篇", label: "吃瓜指南" },
  { num: "9.2w", unit: "人", label: "圈内在场" },
];

export const hotTags = [
  "恋综话术",
  "综艺名场面",
  "剧集烂尾",
  "舞台翻车",
  "选秀爆冷",
  "路透照",
  "剧本带货",
  "赛训内幕",
];